module.exports = __webpack_public_path__ + "static/media/02.918ee511.jpg";